import script from "./SalesRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./SalesRecord.vue?vue&type=script&setup=true&lang=js"

import "./SalesRecord.vue?vue&type=style&index=0&id=67332d8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67332d8e"]])

export default __exports__